var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"okazaki"},[_c('ShopContents',{attrs:{"shopId":_vm.ShopConsts.ID_OKAZAKI}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }